import type {Question} from "src/constants/faqIndex";

export type SectionDivider = {
  title: string;
};

export type QA = {
  q: string;
  a: string | JSX.Element;
  tags?: string[];
};

export type LocalQA = QA & {
  active?: boolean;
  hide?: boolean;
};

export const isSectionDivider = (
  item: SectionDivider | QA | LocalQA | Question,
): item is SectionDivider => typeof (item as SectionDivider)?.title === "string";
